<template>
  <div class="field">
    <label class="label">Abstract</label>
    <div class="control">
      <textarea
        class="textarea is-fullwidth"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PositionAbstract',
  props: {
    value: {
      type: [String],
      required: true
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updatePosition({ position_id: this.positionId, abstract: this.value, active_at: new Date() })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
